import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import Joyride from 'react-joyride';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generalAlertError } from '../../common/utils/alerts';
import { getProductIcon } from '../../common/constants';
import {
  listQuotationsPurchasedRequests,
  resetQuotationsPurchasedRequests,
} from '../../features/quotations/quotationsActions';
import {
  PurchasedQuotationsStyles,
  PageHeader,
  SearchButton,
  EmptyState,
  LoadingState,
  QuotationsList,
} from './PurchasedQuotations.styles';
import {
  BrokerListItemCard,
  BrokerListItemHeader,
  BrokerListItemContent,
  BrokerListItemSection,
  BrokerListItemLabel,
  BrokerListItemValue,
  BrokerListItemStatusBadge,
  BrokerListItemRenewalBadge,
  BrokerListItemDocumentsBadge,
  BrokerListItemAction,
  BrokerListItemFilterCard,
  BrokerListItemRiskGroup,
  BrokerListItemRiskGroupLabel,
  BrokerListItemRiskCard,
} from '../../common/components/BrokerListItem.styles';
import Pagination from '../../common/components/elements/Pagination';
// import { useTourContext } from '../../context/useTourContext';
import ErrorComponent from '../../common/components/ErrorComponent';
// import { joyrideOptions } from '../../common/utils/joyrideUtils';
// import { handleCallbackPurchasedQuotes } from '../../common/utils/joyrideCallbacks';
// import { purchaseQuotationsSteps } from '../../common/utils/joyrideSteps';

function PurchasedQuotations() {
  const state = useSelector((store) => store.quotations.quotations_purchased);

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const {
    loading,
    quotations: savedQuotes,
    page_number,
    total_pages,
    error,
  } = state;

  const [search, setSearch] = useState({
    customer_name: '',
    saved_code: '',
    vehicle_plate: '',
    date_from: '',
    date_to: '',
    documents_signed: '',
  });
  // const [steps, setSteps] = useState([]);

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('quotazioniAquistati') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('quotazioniAquistati')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('quotazioniAquistati');
  //   setState({ run: true, tourActive: true });
  // };

  // useEffect(() => {
  //   purchaseQuotationsSteps(savedQuotes, setSteps);
  // }, [savedQuotes]);

  const searchHandler = (e) => {
    e.preventDefault();

    if (search.date_from !== '' && search.date_to === '') {
      generalAlertError('Devi selezionare anche data al');
      return;
    }

    if (search.date_from === '' && search.date_to !== '') {
      generalAlertError('Devi selezionare anche data da');
      return;
    }

    const trimmedSearch = {
      ...search,
      customer_name: search.customer_name.trim(),
      saved_code: search.saved_code.trim(),
      vehicle_plate: search.vehicle_plate.trim(),
    };

    if (trimmedSearch.documents_signed === '') {
      delete trimmedSearch.documents_signed;
    }

    listQuotationsPurchasedRequests(1, trimmedSearch);
  };

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  useEffect(() => () => {
    resetQuotationsPurchasedRequests();
  }, []);

  const renderGestisciAction = (quote) => {
    if (quote.is_offline == 1) {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/offline`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/auto`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1 && quote.company_id === 16 && ['furto_incendio', 'eventi_naturali', 'eventi_socio_politici'].includes(quote.quote_type)) {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/auto`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1 && quote.quote_type === 'assistenza_stradale') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/assistenza-stradale`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1 && quote.quote_type === 'cristalli') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/cristalli`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1 && quote.quote_type === 'collisione') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/collisione`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1 && quote.quote_type === 'infortuni_conducente') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/infortuni-conducente`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 2 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/moto`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 3 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/autocarro`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 5) {
      return (
        <Link to={`/quotes/metlife/purchase/${quote.request_token}`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 4 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/profession`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 6) {
      return (
        <Link to={`/quotes/infodrive/purchase/${quote.request_token}`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 8 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/travel`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 9 || quote.quote_type === 'tutela_legale') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/tutela-legale`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 10) {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/commercial`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 11) {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/casa`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 12) {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/salute`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 13 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/ancillari-auto`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 13 && quote.quote_type === 'cristalli') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/cristalli`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 13 && quote.quote_type === 'collisione') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/collisione`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 13 && quote.quote_type === 'infortuni_conducente') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/infortuni-conducente`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 14 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/sanitaria-stranieri`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 15 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/rc-professionale-sanita`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1000 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/pubblico-impiego`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1001 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/malattia`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1002 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/infortunio`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1003 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/condominio`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1004 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/rc-famiglia`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    if (quote.product_id == 1006 && quote.quote_type === 'res_civile') {
      return (
        <Link to={`/quotes/purchased/${quote.quotation_id}/quotation/monopattini-elettrici`}>
          <BrokerListItemAction>
            📋 Gestisci
          </BrokerListItemAction>
        </Link>
      );
    }

    return null;
  };

  const renderCardBody = (quote, { linked = false } = {}) => {
    const productName = quote.quote_type !== 'res_civile' && quoteTypes.find((type) => type.id === quote.quote_type)
      ? quoteTypes.find((type) => type.id === quote.quote_type).name
      : quote.product.name;

    const customerName = quote.customer.gender === 'G'
      ? quote.customer.business_name
      : `${quote.customer.name} ${quote.customer.surname}`;

    const plate = quote.vehicle
      ? quote.vehicle.vehicle_plate
      : quote.moto
        ? quote.moto.moto_plate
        : null;

    return (
      <>
        <BrokerListItemHeader>
          <div className="d-flex align-items-center gap-3">
            <div
              style={{
                lineHeight: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FontAwesomeIcon
                icon={getProductIcon(quote.product_id)}
                style={{
                  fontSize: linked ? '1.1rem' : '1.5rem',
                  color: 'white',
                }}
              />
            </div>
            <div className="flex-grow-1">
              <div>
                <h4>
                  POLIZZA
                  {' '}
                  {productName.toUpperCase()}
                  {' '}

                  {(quote.product_id == 1 && quote.company_id === 1005) && '(Servizio non assicurativo)'}
                  -
                  {' '}
                  {customerName.toUpperCase()}
                </h4>
                <p>
                  Data Emissione:
                  {' '}
                  {new Date(
                    quote.emission_date !== null ? quote.emission_date : quote.created_at,
                  ).toLocaleDateString('it-IT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}
                </p>
              </div>
            </div>
            {quote.is_renewal ? (
              <BrokerListItemRenewalBadge>
                <span aria-hidden="true">↻</span>
                Rinnovo
              </BrokerListItemRenewalBadge>
            ) : null}
          </div>
        </BrokerListItemHeader>

        <BrokerListItemContent>
          <div className="row">
            <div className="col-md-4">
              <BrokerListItemSection>
                <BrokerListItemLabel>Contraente</BrokerListItemLabel>
                <BrokerListItemValue>{customerName}</BrokerListItemValue>
              </BrokerListItemSection>

              <BrokerListItemSection>
                <BrokerListItemLabel>Prodotto</BrokerListItemLabel>
                <BrokerListItemValue>{productName}</BrokerListItemValue>
              </BrokerListItemSection>

              <BrokerListItemSection>
                <BrokerListItemLabel>Compagnia</BrokerListItemLabel>
                <BrokerListItemValue>{quote.company_name}</BrokerListItemValue>
              </BrokerListItemSection>

              {plate && (
                <BrokerListItemSection>
                  <BrokerListItemLabel>Targa</BrokerListItemLabel>
                  <BrokerListItemValue>{plate}</BrokerListItemValue>
                </BrokerListItemSection>
              )}

              {quote.professional && (
                <BrokerListItemSection>
                  <BrokerListItemLabel>Professione</BrokerListItemLabel>
                  <BrokerListItemValue>{quote.professional.profession_desc}</BrokerListItemValue>
                </BrokerListItemSection>
              )}

              <BrokerListItemSection>
                <BrokerListItemLabel>Data Emissione</BrokerListItemLabel>
                <BrokerListItemValue>
                  {new Date(
                    quote.emission_date !== null ? quote.emission_date : quote.created_at,
                  ).toLocaleDateString('it-IT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}
                </BrokerListItemValue>
              </BrokerListItemSection>

              {quote.saved_code_id && (
                <BrokerListItemSection>
                  <BrokerListItemLabel>Codice Preventivo</BrokerListItemLabel>
                  <BrokerListItemValue>{quote.saved_code_id}</BrokerListItemValue>
                </BrokerListItemSection>
              )}
            </div>

            <div className="col-md-4">
              <BrokerListItemSection>
                <BrokerListItemLabel>Garanzie incluse</BrokerListItemLabel>
                <BrokerListItemValue>
                  {quote.guarantees && quote.guarantees.length > 0 ? (
                    <div className="d-flex flex-column" style={{ gap: '0.5rem' }}>
                      {quote.guarantees.filter((el) => (quote.quote_type === 'res_civile' ? el.company_id === quote.company_id : el.type === quote.quote_type)).map((guarantee, idx) => (
                        <div key={idx} style={{ fontSize: '0.85rem' }}>
                          <span style={{ fontWeight: '500', color: '#333' }}>
                            {guarantee.name}

                          </span>
                          {' '}
                          <span style={{ color: '#00a651', fontWeight: '600' }}>
                            {guarantee.price && guarantee.price !== 0 ? (
                              <>
                                :
                                {' '}
                                €
                                {' '}
                                {guarantee.price.toLocaleString('it-IT', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </>
                            ) : ''}
                          </span>
                        </div>
                      ))}
                      {Number(quote.brokerage_amount || 0) !== 0 && (
                        <div style={{ fontSize: '0.85rem' }}>
                          <span style={{ fontWeight: '500', color: '#333' }}>
                            Brokeraggio:
                          </span>
                          {' '}
                          <span style={{ color: '#00a651', fontWeight: '600' }}>
                            €
                            {' '}
                            {Number(quote.brokerage_amount).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                      )}

                      {quote.extra_services && (
                        <div style={{ fontSize: '0.85rem' }}>
                          <span style={{ fontWeight: '500', color: '#333' }}>
                            {quote.extra_services[0].service_name}
                            :
                          </span>
                          {' '}
                          <span style={{ color: '#00a651', fontWeight: '600' }}>
                            €
                            {' '}
                            {Number(quote.extra_services[0].total_price).toLocaleString('it-IT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>

                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ color: '#888', fontSize: '0.85rem', fontStyle: 'italic' }}>
                      Nessuna garanzia
                    </div>
                  )}
                </BrokerListItemValue>
              </BrokerListItemSection>

              <div style={{ marginTop: linked ? '0.75rem' : '1.5rem', fontSize: linked ? '0.85rem' : '0.95rem' }}>
                <span style={{ fontWeight: '600', color: '#333' }}>
                  Totale:
                </span>
                {' '}
                <span style={{ fontSize: linked ? '1rem' : '1.1rem', fontWeight: '900', color: '#00a651' }}>
                  €
                  {' '}
                  {(
                    (Array.isArray(quote.guarantees) && quote.guarantees.length > 0
                      ? quote.guarantees
                        .filter((g) => (quote.quote_type === 'res_civile' ? g.company_id === quote.company_id : g.type === quote.quote_type))
                        .reduce((sum, g) => sum + Number(g.price || 0), 0)
                      : Number(quote.amount || 0))
                    + Number(quote.brokerage_amount || 0) + (quote.extra_services && Number(quote.extra_services[0].total_price))
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
              </div>
              {quote.payment_frequency === 2 && (
                <div
                  style={{
                    marginTop: '0.75rem',
                    paddingTop: '0.75rem',
                    borderTop: '2px solid #e8e8e8',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.4rem',
                  }}
                >
                  {quote.guarantees.filter((el) => (quote.quote_type === 'res_civile' ? el.company_id === quote.company_id : el.type === quote.quote_type)).map((guarantee, guaranteeIndex) => (
                    <div key={guaranteeIndex} style={{ fontSize: '0.85rem' }}>
                      <span style={{ fontWeight: '500', color: '#333' }}>
                        {guarantee.name}

                      </span>
                      {' '}
                      <span style={{ color: '#00a651', fontWeight: '600' }}>
                        {guarantee.price && guarantee.price !== 0 ? (
                          <>
                            :
                            {' '}
                            €
                            {' '}
                            {(Number(guarantee.price) / 2).toLocaleString('it-IT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </>
                        ) : ''}
                      </span>
                    </div>
                  ))}
                  {Number(quote.brokerage_amount || 0) !== 0 && (
                    <div style={{ fontSize: '0.85rem' }}>
                      <span style={{ fontWeight: '500', color: '#333' }}>
                        Brokeraggio:
                      </span>
                      <span style={{ color: '#00a651', fontWeight: '600' }}>
                        {' '}
                        €
                        {' '}
                        {(Number(quote.brokerage_amount) / 2).toLocaleString('it-IT', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  )}
                  {quote.extra_services && (
                    <div style={{ fontSize: '0.85rem' }}>
                      <span style={{ fontWeight: '500', color: '#333' }}>
                        {quote.extra_services[0].service_name}
                        :
                      </span>
                      <span style={{ color: '#00a651', fontWeight: '600' }}>
                        {' '}
                        €
                        {' '}
                        {Number(quote.extra_services[0].added_at_installment === 2 ? quote.extra_services[0].total_price : quote.extra_services[0].total_price / quote.payment_frequency).toLocaleString('it-IT', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  )}

                  <div
                    style={{
                      fontSize: '0.95rem',
                      marginTop: '0.5rem',
                      paddingTop: '0.5rem',
                      borderTop: '1px solid #e8e8e8',
                    }}
                  >
                    <span style={{ fontWeight: '600', color: '#333' }}>
                      Semestrale:
                    </span>
                    {' '}
                    <span
                      style={{
                        fontSize: '1.1rem',
                        fontWeight: '900',
                        color: '#00a651',
                      }}
                    >
                      €
                      {' '}
                      {(
                        (
                          (Array.isArray(quote.guarantees) && quote.guarantees.length > 0
                            ? quote.guarantees
                              .filter((g) => (quote.quote_type === 'res_civile' ? g.company_id === quote.company_id : g.type === quote.quote_type))
                              .reduce((sum, g) => sum + Number(g.price || 0), 0)
                            : Number(quote.amount || 0))
                          + Number(quote.brokerage_amount || 0)
                        ) / 2 + (quote.quote_type === 'res_civile'
                          ? (quote.extra_services && quote.extra_services[0] ? Number(quote.extra_services[0].added_at_installment === 2 ? quote.extra_services[0].total_price : quote.extra_services[0].total_price / quote.payment_frequency) : 0)
                          : 0)
                      ).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>

                </div>
              )}
            </div>

            <div className="col-md-4 d-flex flex-column">
              <div className="d-flex flex-column align-items-end gap-3 mb-3">
                <BrokerListItemStatusBadge variant="new">
                  {quote.quotation_status.name}
                </BrokerListItemStatusBadge>
                <BrokerListItemDocumentsBadge signed={quote.are_documents_signed === 1 || quote.are_documents_signed === true}>
                  {quote.are_documents_signed === 1 || quote.are_documents_signed === true ? 'Documenti Firmati' : 'Documenti Non Firmati'}
                </BrokerListItemDocumentsBadge>
              </div>

              <div className="mt-auto d-flex justify-content-end">
                {renderGestisciAction(quote)}
              </div>
            </div>
          </div>
        </BrokerListItemContent>
      </>
    );
  };

  return error === null ? (
    <PurchasedQuotationsStyles>
      <div className="container-fluid">
        <PageHeader>
          <h2>📄 Lista Polizze Emesse</h2>
        </PageHeader>

        <BrokerListItemFilterCard className="quotazioni-aquistati-three mb-4">
          <form onSubmit={searchHandler}>
            <div className="row g-3">
              <div className="col-md-3">
                <label htmlFor="customer_name" className="form-label small">Contraente</label>
                <input
                  type="text"
                  name="customer_name"
                  id="customer_name"
                  className="form-control form-control-sm"
                  value={search.customer_name}
                  onChange={handleChange}
                  placeholder="Nome, cognome..."
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="saved_code" className="form-label small">Codice Preventivo</label>
                <input
                  type="text"
                  name="saved_code"
                  id="saved_code"
                  className="form-control form-control-sm"
                  value={search.saved_code}
                  onChange={handleChange}
                  placeholder="Codice..."
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="vehicle_plate" className="form-label small">Targa</label>
                <input
                  type="text"
                  name="vehicle_plate"
                  id="vehicle_plate"
                  className="form-control form-control-sm"
                  value={search.vehicle_plate}
                  onChange={handleChange}
                  placeholder="Targa..."
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="documents_signed" className="form-label small">Documenti Firmati</label>
                <select
                  name="documents_signed"
                  id="documents_signed"
                  className="form-control form-control-sm"
                  value={search.documents_signed}
                  onChange={handleChange}
                >
                  <option value="">Tutti</option>
                  <option value="1">Si</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>
            <div className="row g-3 mt-1">
              <div className="col-md-3">
                <label htmlFor="date_from" className="form-label small">Data da</label>
                <input
                  type="date"
                  name="date_from"
                  id="date_from"
                  onChange={handleChange}
                  value={search.date_from}
                  className="form-control form-control-sm"
                  lang="it-IT"
                />
              </div>
              <div className="col-md-3">
                <label htmlFor="date_to" className="form-label small">Data al</label>
                <input
                  type="date"
                  name="date_to"
                  id="date_to"
                  className="form-control form-control-sm"
                  onChange={handleChange}
                  value={search.date_to}
                  min={search.date_from}
                  lang="it-IT"
                />
              </div>
            </div>
            <div className="d-flex gap-2 mt-3" style={{ justifyContent: 'flex-start' }}>
              <SearchButton type="submit" style={{ padding: '8px 24px', fontSize: '14px', width: 'auto' }}>
                Cerca
              </SearchButton>
              <SearchButton
                type="button"
                style={{
                  background: '#6c757d', borderColor: '#6c757d', padding: '8px 24px', fontSize: '14px', width: 'auto',
                }}
                onClick={() => {
                  const emptyFilters = {
                    customer_name: '',
                    saved_code: '',
                    vehicle_plate: '',
                    date_from: '',
                    date_to: '',
                    documents_signed: '',
                  };
                  setSearch(emptyFilters);
                  resetQuotationsPurchasedRequests();
                }}
              >
                Pulisci Filtri
              </SearchButton>
            </div>
          </form>
        </BrokerListItemFilterCard>

        <div className="row">
          {/* Main Content */}
          <div className="col-12">
            {loading ? (
              <LoadingState className="quotazioni-aquistati-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento polizze in corso...</span>
              </LoadingState>
            ) : (
              <>
                <QuotationsList className="quotazioni-aquistati-one">
                  {savedQuotes.length > 0 ? (
                    savedQuotes.map((quote) => (
                      <BrokerListItemCard
                        key={quote.quotation_id}
                        className="quotazioni-aquistati-two"
                      >
                        {renderCardBody(quote)}

                        {Array.isArray(quote.risk_quotations) && quote.risk_quotations.length > 0 && (
                          <BrokerListItemRiskGroup>
                            <div className="row">
                              <div className="col-md-3">
                                <BrokerListItemRiskGroupLabel>Altre Garanzie</BrokerListItemRiskGroupLabel>
                              </div>
                              <div className="col-md-9">
                                {quote.risk_quotations.map((risk) => (
                                  <BrokerListItemRiskCard key={risk.quotation_id}>
                                    {renderCardBody(risk, { linked: true })}
                                  </BrokerListItemRiskCard>
                                ))}
                              </div>
                            </div>
                          </BrokerListItemRiskGroup>
                        )}
                      </BrokerListItemCard>
                    ))
                  ) : (
                    <EmptyState className="quotazioni-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Trova con facilità le polizze che cerchi</h5>
                      <p>Utilizza i filtri per trovare una polizza o clicca su &quot;Cerca&quot; per visualizzare le ultime emesse</p>
                    </EmptyState>
                  )}
                </QuotationsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listQuotationsPurchasedRequests}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </PurchasedQuotationsStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default PurchasedQuotations;
